import { GET_SUGGESTIONS, SELECT_SUGGESTION, SET_SUGGESTIONS } from "../actionTypes";

export const getSuggestions = (query, useExact) => ({
  type: GET_SUGGESTIONS,
  payload: { query: query, useExact: useExact }
});

export const setSuggestions = (suggestions) => ({
  type: SET_SUGGESTIONS,
  payload: suggestions
});

export const selectSuggestion = (suggestion, key) => ({
  type: SELECT_SUGGESTION,
  payload: {suggestion: suggestion, key: key}
});